import { MapPin, Phone } from 'lucide-react';
import { SiteLayout } from '../components/site/SiteLayout';
import { Eyebrow } from '../components/site/PageHero';
import { ContactForm } from '../components/site/ContactForm';
import { SocialLinks } from '../components/site/SocialLinks';
import { PHONES } from '../lib/site';

const InfoRow = ({ Icon, title, children }) => (
  <div className="flex items-start gap-4">
    <div className="w-12 h-12 rounded-2xl bg-orange-500/15 border border-orange-400/30 flex items-center justify-center shrink-0">
      <Icon className="w-5 h-5 text-orange-300" />
    </div>
    <div>
      <h3 className="font-semibold text-white mb-1">{title}</h3>
      {children}
    </div>
  </div>
);

export default function Contact() {
  return (
    <SiteLayout testid="contact-page">
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 md:pt-24 pb-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 space-y-10">
          <div className="space-y-6">
            <div className="rise-in"><Eyebrow>Contact</Eyebrow></div>
            <h1 className="rise-in font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight" style={{ animationDelay: '80ms' }}>
              Get in <span className="text-orange-400">touch</span>
            </h1>
            <p className="rise-in text-base md:text-lg text-slate-300" style={{ animationDelay: '160ms' }}>Have questions? We're here to help. Send us a message and we'll respond as soon as possible.</p>
          </div>
          <div className="space-y-7">
            {Object.values(PHONES).map((p) => (
              <InfoRow key={p.key} Icon={Phone} title={p.label}>
                <a href={p.tel} data-testid={`contact-phone-${p.key}`} className="text-lg text-slate-300 hover:text-orange-400">{p.display}</a>
              </InfoRow>
            ))}
            <InfoRow Icon={MapPin} title="Location">
              <p className="text-slate-300">Serving Clients in 19 States</p>
              <p className="text-sm text-slate-500 mt-1">In-person & virtual consultations available</p>
            </InfoRow>
          </div>
          <div className="space-y-3">
            <p className="text-xs uppercase tracking-[0.3em] text-slate-500">Follow us</p>
            <SocialLinks prefix="contact" />
          </div>
        </div>
        <div className="lg:col-span-7 rise-in" style={{ animationDelay: '200ms' }}>
          <ContactForm />
        </div>
      </section>
    </SiteLayout>
  );
}
